<template>
    <div class="block-box">
        <div class="block-item">
            <div :span="6" class="label">
                {{configData.title}}
            </div>
            <el-col :span="14" class="color-box">
                <div class="color-item" v-for="(color,key) in configData.color" :key="key">
                    <el-color-picker v-model="color.item" show-alpha/>
                    <span class="span" @click="resetBgA(color, key)">重置</span>
                </div>
            </el-col>
        </div>
    </div>
</template>

<script>
    export default {
        name: "colors",
        props: {
            configData: {
                type: Object,
                default: {}
            },
        },
        methods: {
            // 重置
            resetBgA (color, key) {
                color.item = this.configData.default[key].item
            }
        }
    }
</script>

<style scoped>

</style>
